export default __webpack_public_path__ + "static/media/print_kouji_2.8820989e.svg";